<template>
  <div v-if="order" class="pay notranslate">
    <h1 class="boxTitle mb15 toCapitalize">{{locale.order_payment}}</h1>
    <div class="payBox">
      <Summary
        :locale="locale"
        :lang="lang"
        :summary="orderList" />
    </div>
    <div class="payBox toCapitalize">
      <h2 class="payTitle toCapitalize">{{locale.payment_information}}</h2>
      <div v-if="order.price.info.tax || order.price.info.tip" class="tax">
        <div class="payInfo">
          <span class="label">{{locale.subtotal}}</span>
          <span class="value">{{priceFormat(order.price.info.subtotal)}}</span>
        </div>
        <div v-if="order.price.info.tax && order.disabledTax !== true">
          <div class="payInfo">
            <span class="label">{{locale.tax}}({{order.price.info.taxLabel}})</span>
            <span class="value">{{priceFormat(order.price.info.tax)}}</span>
          </div>
        </div>
        <div v-if="order.price.info.tip" class="payInfo">
          <div class="label">
            {{locale.tip}}
            <span v-if="order.price.info.tipLabel !== '' && order.price.info.tipLabel.includes('%')">
              ({{order.price.info.tipLabel}}<em v-if="order.price.info.tipIncludeTax">/{{locale.tip_include_tax}}</em>)
            </span>
          </div>
          <span class="value">{{priceFormat(order.price.info.tip)}}</span>
        </div>
      </div>
      <div v-if="order.price.info.discount" class="tax">
        <div class="payInfo">
          <span class="label">{{locale.discount}}</span>
          <span class="value">-{{priceFormat(order.price.info.discount)}}</span>
        </div>
      </div>
      <div class="payInfo">
        <span class="label">{{locale.payment_amount}}</span>
        <span class="value">{{priceFormat(order.price.info.total)}}</span>
      </div>
    </div>
    <!-- 취소, 환불약관 -->
    <TermsRefund
      v-if="!isRoomCharge"
      :lang="lang"
      :locale="locale" />
    <!-- //취소, 환불약관 -->
    <div class="btns mt30 toCapitalize">
      <p class="pleaseConfirm">{{locale.order_confirm_message}}</p>
      <button
        type="button"
        class="btn btnRound btnFull toCapitalize"
        :class="{btnDisabled: disabledRequest}"
        @click.stop="request">{{locale.do_order}}</button>
    </div>
    <div>
      <PaymentQrCode
        v-if="isPublic && qrCode && !isRoomCharge"
        :qrCode="qrCode"
        :lang="lang"
        :locale="locale"
        @close="closeQr" />
      <component v-if="component"
        :is="component"
        :locale="locale"
        :order="order"
        @close="closeComponent" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import regExp from '@/common/regExp'
import TermsRefund from '@/components/Payment/TermsRefund.vue'
import Summary from '@/components/Payment/Summary.vue'
import PaymentQrCode from '@/components/Payment/Qrcode.vue'

export default {
  name: 'Payment',
  props: [
    'locale',
    'lang',
    'isPublic',
    'payment'
  ],
  components: {
    TermsRefund,
    Summary,
    PaymentQrCode
  },
  computed: {
    ...mapGetters({
      getTax: 'payment/getTax'
    }),
    siteinfo () {
      return this.$store.state.authentication
    },
    tax () {
      return this.$store.state.payment.tax
    },
    orderId () {
      return this.$route.params.paymentId
    },
    orderList () {
      const order = this.order
      const isArray = order && order.isArray
      const list = isArray ? order.payload : [order]
      return list
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    disabledRequest () {
      const agreeList = this.$store.getters['payment/getAgree']
      const disagree = Object.values(agreeList).includes(false)
      return !this.isRoomCharge && disagree
    },
    isRoomCharge () {
      return this.payment === 'roomCharge'
    }
  },
  mounted () {
    const store = this.$store.getters['payment/getOrder']
    const order = store
    if (!order) {
      this.$router.push({ name: 'paymentStep', params: { ...this.$route.params } })
    } else {
      const orderData = order && order.payload
        ? {
          ...order,
          payload: order.payload
        }
        : order
      const payloadTotal = orderData && orderData.payload
        ? orderData.payload
          .filter(x => x.price && x.price.info && x.price.info.total)
          .map(x => x.price.info.total)
          .reduce((a, b) => {
            return a + b
          }, 0)
        : 0
      this.order = {
        ...orderData,
        price: {
          ...orderData.price,
          info: {
            ...orderData.price.info,
            total: payloadTotal
          },
          total: payloadTotal
        },
        total: payloadTotal
        // ...orderData.payload && [

        // ],
        // ...orderData.price && {
        //   price: {
        //     ...orderData.price,
        //     info: {
        //       ...orderData.price.info,
        //       total: payloadTotal
        //     },
        //     total: payloadTotal
        //   }
        // },
        // total: payloadTotal
      }
    }
  },
  data () {
    return {
      order: null,
      amenity: null,
      component: null,
      qrCode: null
    }
  },
  methods: {
    closeQr () {
      this.qrCode = null
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    closeComponent () {
      this.component = null
    },
    validate () {
      if (this.disabledRequest) {
        alert(this.locale.alert_agree_terms)
        return false
      } else {
        return true
      }
    },
    deleteCart (cartIds) {
      const Store = this.$store
      cartIds.forEach(function (cartId, index) {
        localStorage.removeItem(cartId)
        Store.commit('cart/delList', cartId)
        return index + 1 === cartIds.length
      })
    },
    async validCoupons () {
      let result = true
      const hascoupons = this.order && this.order.payload && this.order.payload.filter(x => x.useCoupon && x.useCoupon.useCoupon && x.useCoupon.useCoupon.length > 0).length > 0
      if (hascoupons) {
        const getIids = function (payload) {
          let result = []
          const arr = payload.filter(x => x.useCoupon && x.useCoupon.useCoupon && x.useCoupon.useCoupon.length > 0)
          for (let i = 0; i < arr.length; i++) {
            const coupon = arr[i].useCoupon.useCoupon
            result.concat(coupon.map(x => x.iid))
          }
          return result
        }
        const iid = getIids(this.order.payload)
        // 쿠폰 유효성 체크 (request는 여기서 끝남)
        await this.$store.dispatch('coupon/getCoupon').then((res) => {
          const validCoupons = this.$store.getters['util/validateCoupon'](res, iid)
          if (!validCoupons) {
            alert(this.locale.alert_get_coupon_disabled)
            result = false
          }
        })
      }
      return result
    },
    async setRoomCharge () {
      const data = this.$store.getters['payment/getOrder']
      const cartIds = this.$route.params.cartIds
      const items = data.payload
        ? {
          ...data,
          payload: data.payload.filter(x => x.cartId !== 'system_amenity')
        }
        : data
      const amenities = data.payload ? data.payload.find(x => x.cartId === 'system_amenity') : null
      const url = new URL(this.order.returnURL)
      const routerPath = url.hash.replace('#', '')
      const validCoupons = await this.validCoupons()
      this.$store.commit('loading', true)
      if (data) {
        // 어메니티는 따로 우선 요청 (object)
        if (amenities) {
          this.$store.dispatch('submit/request', amenities)
        }
        // 나머지 아이템은 한꺼번에 요청 (array)
        if (validCoupons) {
          this.$store.dispatch('submit/request', amenities ? { ...items, paid: false } : { ...data, paid: false }).then((res) => {
            if (res && res.status === 200) {
              if (cartIds) {
                this.deleteCart(cartIds)
              }
              this.$router.push({ path: routerPath })
              this.$store.commit('loading', false)
            } else {
              this.$store.commit('loading', false)
            }
          })
        } else {
          this.$store.commit('loading', false)
        }
      } else {
        alert(`${this.locale.payment_system_error}\n${this.locale.payment_progress_again}`)
        this.messageLayer = false
        this.$store.commit('loading', false)
      }
    },
    async setPayment () {
      const siteinfo = this.siteinfo
      const win = window.location
      let params = publicToOta(win.search)
      let paymentUrl = ''
      const paymentData = { ...this.order, paid: true }
      // 공용디바이스 사용자는 개인링크로 변환 params
      function publicToOta (queryString) {
        const params = {}
        queryString.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
          params[key] = value
        })
        return params
      }
      const validCoupons = await this.validCoupons()
      if (validCoupons) {
        this.$store.commit('loading', true)
        this.$store.dispatch('payment/getOrderId', paymentData).then((res) => {
          const payment = res.payment
          const pgid = res.pgid
          const paymentComponent = payment ? payment.replace(/\b\w/g, l => l.toUpperCase()) : null
          if (!payment) {
            this.component = null
            if (res.message.includes('Unauthorized')) {
              // 유효하지 않은 인증키입니다.
              alert(this.locale.invalid_key)
              window.location.reload()
            } else if (res.message.includes('amount')) {
              // 결제할 수 없는 금액입니다.
              alert(this.locale.alert_amount_cannot_paid)
            } else if (res.message.includes('currency')) {
              // 지원하지 않는 통화입니다.
              alert(this.locale.alert_currency_not_support)
            } else {
              // 시스템에러가 발생했습니다.
              alert(this.locale.alert_system_error)
            }
          } else {
            if (this.isPublic) {
              delete params.public
              params.k = siteinfo.k
              params = Object.entries(params).map(e => e.join('=')).join('&')
              paymentUrl = `${win.origin}${win.pathname}?${params}&frame=false#/${this.lang}/payment/separate/${payment}/${pgid}`
              this.$store.dispatch('util/getShortUrl', {
                url: paymentUrl,
                days: 1
              }).then((res) => {
                this.qrCode = res
              })
            } else {
              this.component = () => import(`@/components/Payment/${paymentComponent}.vue`)
            }
          }
          this.$store.commit('loading', false)
        })
      }
    },
    request () {
      if (this.validate()) {
        const isRoomCharge = this.payment && this.payment === 'roomCharge'
        if (isRoomCharge) {
          this.setRoomCharge()
        } else {
          this.setPayment()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pleaseConfirm {
  margin-bottom: 5px;
  text-align: center;
  font-weight: normal;
  color: $color-red;
}
</style>
